export const OUTLAW_API_ROUTES = {
  userRoute: '/auth/user/',
  checkAccessToken: '/external/check_access_token/',
};
